import { useShouldUseLazyAnalytics } from '@/utils/hooks/post/useShouldUseLazyAnalytics';

import { classNames } from '@/utils';

import PropTypes from 'prop-types';

import { DEFAULT_POST_CONFIG } from '@/lib/posts/defaultPostConfig';
import { PI_POST_ICONS } from '@/lib/posts/postIcon';
import { getPostType, PI_POST_TYPES, POST } from '@/lib/posts/postTypes';
//lib
import { PINTEREST } from '@/lib/socialProfile';

//components
import Post from '@/components/base/Post';
import HoverLabelAndAlbums from '@/components/base/Post/HoverLabelAndAlbums';
import LazyAnalyticsFooter from '@/components/base/Post/LazyAnalyticsFooter';

const PinterestPost = ({
    data,
    isLoading,
    config,
    openViewer,
    handleLabelsEvent,
    handleAlbumsEvent,
    postConfig = DEFAULT_POST_CONFIG,
    remoteMedia = false,
    feedType = null,
    isExport = false,
    showHeader = true,
    isDashboard = false,
    ...restProps
}) => {
    const mergedPostConfig = { ...DEFAULT_POST_CONFIG, ...postConfig };
    const type = getPostType({ network: PINTEREST, type: data?.type });
    const shouldUseLazyAnalytics = useShouldUseLazyAnalytics(PINTEREST, isDashboard);

    if (isLoading) {
        return <Post.Placeholder postType={POST} isExport={isExport} />;
    }

    return (
        <div className="w-full">
            {showHeader && <Post.Header data={data} isExport={isExport} />}
            <Post
                data={data}
                config={config}
                isLoading={isLoading}
                className={classNames('w-full bg-white', {
                    'p-2': !mergedPostConfig?.hasFooter && mergedPostConfig?.hasHover,
                    'p-0.5': !mergedPostConfig?.hasFooter && !mergedPostConfig?.hasHover,
                    'px-1 pt-1': mergedPostConfig?.hasFooter,
                    'dark:bg-icoDarkMode-anthracite': !isExport
                })}
                isExport={isExport}
                {...restProps}>
                {({ referenceElement }) => (
                    <>
                        <Post.Content className="w-full">
                            {mergedPostConfig?.hasHover ? (
                                <HoverLabelAndAlbums
                                    openViewer={openViewer}
                                    referenceElement={referenceElement}
                                    handleLabelsEvent={handleLabelsEvent}
                                    handleAlbumsEvent={handleAlbumsEvent}
                                    showLabels={mergedPostConfig?.showLabels}
                                    showAlbums={mergedPostConfig?.showAlbums}
                                    socialProfile={data?.social_profile}
                                />
                            ) : null}
                            {type && type !== PI_POST_TYPES.TYPE_IMAGE ? (
                                <Post.PostTypeIcon type={PI_POST_ICONS[type]} isExport={isExport} />
                            ) : null}
                            <div className="square">
                                <Post.Image remoteMedia={remoteMedia} />
                            </div>
                        </Post.Content>
                        {mergedPostConfig?.hasFooter ? (
                            shouldUseLazyAnalytics && data?.id && data?.social_profile_id ? (
                                <LazyAnalyticsFooter
                                    type={type}
                                    mediaId={data.id}
                                    socialProfileId={data.social_profile_id}
                                    network={PINTEREST}
                                    feedType={feedType ?? ''}
                                />
                            ) : (
                                <Post.Footer feedType={feedType} type={type} />
                            )
                        ) : null}
                    </>
                )}
            </Post>
        </div>
    );
};

PinterestPost.propTypes = {
    data: PropTypes.object,
    isLoading: PropTypes.bool,
    config: PropTypes.object,
    openViewer: PropTypes.func,
    addLabel: PropTypes.func,
    addAlbum: PropTypes.func
};

export default PinterestPost;
